import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";



import {
  Box,
  Container,
  Divider,
  Grid2,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../theme/theme";

const Footer = () => {


 

  return (
    <footer
    id="contact"
    >
      <Box
        sx={{
          color: "background.default",
          padding: "1rem",
          marginTop: "5rem",
        }}
      >
        <Container>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
              width: "130",
              height: "100px",
            }}
          >
            <Link to="/">
            <img
              
              src="/taal-logo.png"
              alt="Taal Travels"
              style={{
                width: "150px",
                height: "100px",
                objectFit:'contain'
              }}
            />
            </Link>
          </Box>
          <Grid2 container spacing={2}>
            {/* About */}
          
            <Grid2 size={{ xs: 12 }}
              
            >
<Box
              sx={{
                marginTop: "4rem",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              }}
            >
             <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.794505314746!2d55.68076680000001!3d25.2774973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef593e67d4dbdd7%3A0x3009cba7cc71dcec!2sTAAL%20Travel%20%26%20Visa!5e0!3m2!1sar!2seg!4v1739476557688!5m2!1sar!2seg"
  title="Ruh Travels"
  width="100%"
  height="200"
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  style={{ border: "0", borderRadius: "8px" }}
></iframe>

            </Box>
</Grid2>
          




           
          </Grid2>
          <Divider sx={{ marginTop: "1.5rem", borderColor: "gray" }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
              gap: 2,

              textAlign: "center",
            }}
          >
            <a
              href="https://api.whatsapp.com/send/?phone=971528918124"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <>
                <WhatsAppIcon
                  sx={{
                    color: "white",
                    fontSize: "2.6rem",
                    padding: "0.5rem",
                    backgroundColor: "#25d366",
                    borderRadius: "50%",

                    border: "1px solid #25d366",
                    textAlign: "center",
                    transition: "0.5s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#00c6ff",
                    },
                  }}
                />
              </>
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61571096193365
"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <>
                <FacebookRoundedIcon
                  sx={{
                    backgroundColor: "#3b5998",
                    borderRadius: "50%",
                    fontSize: "2.6rem",
                    color: "white",
                    padding: "0.5rem",
                    transition: "0.5s ease-in-out",
                    border: "1px solid #3b5998",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                />
              </>
            </a>
            <a
              href="https://www.instagram.com/taal_travel_visa/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <>
                <InstagramIcon
                  sx={{
                    background:
                      "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                    borderRadius: "50%",
                    padding: "0.5rem",
                    fontSize: "2.6rem",
                    color: "white",
                    transition: "0.5s ease-in-out",
                    border: "1px solid #cc2366",
                    "&:hover": {
                      background:
                        "linear-gradient(45deg, #00c6ff 0%, #0072ff 100%)", 
                    },
                  }}
                />
              </>
            </a>


            <a
              href="mailto:Tareq@taal-travel.com  "
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <>
                <EmailIcon
                  sx={{
                    backgroundColor: "#ff0000",
                    borderRadius: "50%",
                    padding: "0.5rem",
                    fontSize: "2.6rem",
                    color: "white",
                    transition: "0.5s ease-in-out",
                    border: "1px solid #ff0000",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                />
              </>
            </a>
          <a
              href="tel:+971528918124"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <>
                <LocalPhoneRoundedIcon
                  sx={{
                    backgroundColor: "#0077b5",
                    borderRadius: "50%",
                    padding: "0.5rem",
                    fontSize: "2.6rem",
                    color: "white",
                    transition: "0.5s ease-in-out",
                    border: "1px solid #0077b5",
                    "&:hover": {
                      backgroundColor: "#ff0000",
                    },
                  }}
                />
              </>
            </a> 
          </Box>

          <Divider sx={{ marginTop: "1.5rem", borderColor: "gray" }} />

          <Typography
            variant="body2"
            sx={{
              textAlign: "center",
              marginTop: "1.2rem",
              color: "#0063A1",
            }}
          >
            &copy; {new Date().getFullYear()}  TAAL All Rights Reserved
          </Typography>
          {/* Developer */}
          <Box
  sx={{
    textAlign: "center",
    padding: "2rem",
  }}
>
  <Typography variant="caption" color="black">
    Designed and Developed by{" "}
   
    <a
      href="https://shimaamohamed.bio.link/"
      style={{
        color: "gray",
        textDecoration: "none",
        transition: "0.5s ease-in-out",
        cursor: "pointer",
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Typography
        variant="caption"
        sx={{
          color: "gray",
          cursor: "pointer",
          "&:hover": {
            color: "#ffc107",
            textDecoration: "underline",
          },
          display: "inline",
        }}
      >
        Soft Masters
      </Typography>
    </a>
  </Typography>
</Box>

      

          
        </Container>
      </Box>
    </footer>
  );
};

export default Footer;
